var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3635 0.636353H0.63623V33.3636H33.3635V0.636353ZM10.793 6.27899L16.2297 8.18183L10.793 9.66457V13.0501L16.2297 14.953L10.793 16.4357V19.8213L16.4356 21.7962L10.793 23.2069V26.5925L22.0782 30.5423V27.1567L16.4356 25.1818L22.0782 23.7711V20.3856L16.4356 18.4106L22.0782 17V13.6144L16.4356 11.6395L22.0782 10.2288V6.84325L10.793 2.89341V6.27899Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinLayer);
export default __webpack_public_path__ + "static/media/ProteinLayer.e2ce1bc573c7103f7a384b2839401db9.svg";
export { ForwardRef as ReactComponent };